module.exports = __webpack_public_path__ + "./images/49edc5439dec47e5a51626513bfead1c.svg";